import { FC, useCallback, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { withProcedureWraper } from "../../..";
import { getEnv } from "../../../../../AppConfigs";
import { Routes } from "../../../../../AppRoutes";
import { Icon } from "../../../../../components/icon";
import { ProcessContextProvider, ProcessContextType } from "../../../process-context";
import EprInformation from "./information";
import EprProgress from "./progress";
import { useUser } from "../../../../../hook";
import { useUpdateEPR } from "../hooks/use-update-EPR";
import { useDetailsEPR } from "../hooks/use-details-EPR";
import { Spin } from "antd";

export const siteUrl = getEnv("REACT_APP_APPROVER_SABRE_EPR_REQUEST_URL");

export const processEprDetailPage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const [comment, setComment] = useState("");
  const { updateEPRRequest } = useUpdateEPR();
  const { email } = useUser();
  const { data: eprCodeRequest, isLoading, isPin: hasPin, approvalStep, approvalType } = useDetailsEPR();

  const handleUpdatePin = useCallback(
    async (isPin: boolean) => {
      try {
        if (!eprCodeRequest) return;
        const pins: any[] = eprCodeRequest.fields.ePins ? JSON.parse(eprCodeRequest.fields.ePins) : [];
        const index = pins.findIndex((pin: string) => pin === email?.toLowerCase());
        if (!isPin && index < 0) return;
        if (isPin && index > -1) return;
        if (!isPin && index > -1) pins.splice(index, 1);
        if (isPin && index < 0) pins.push(email?.toLowerCase());

        const fields = {
          ePins: JSON.stringify(pins),
        };

        updateEPRRequest(
          { id: eprCodeRequest.id, body: fields },
          { successText: hasPin ? "Bỏ ghim thành công" : "Ghim thành công" },
        );
      } catch (error) {
        console.log(error);
      }
    },
    [email, eprCodeRequest, updateEPRRequest],
  );

  const handleGoBack = () => {
    history.push(Routes.procedureProcessEpr.path);
  };

  const ctx = useMemo<ProcessContextType>(
    () => ({
      Request: eprCodeRequest,
      comment,
      approvalStep,
      approvalType,
      setComment,
      updatePin: handleUpdatePin,
      isPin: () => hasPin,
    }),
    [approvalStep, approvalType, comment, eprCodeRequest, handleUpdatePin, hasPin],
  );

  if (isLoading) return <Spin />;

  return (
    <div className="ItCodeGrantedDetailPage pd15">
      <div className="PageHead">
        <div className="title">
          <div className="btnBack" onClick={handleGoBack}>
            <Icon.ArrowLeft />
          </div>
          {"Xem Xét Yêu Cầu Duyệt"}
        </div>
      </div>

      <ProcessContextProvider context={ctx}>
        <EprProgress />
        <EprInformation />
      </ProcessContextProvider>
    </div>
  );
});
